/**
 * BrandTitle — the two-tone page-title style.
 * =============================================
 * Renders a title with the CARTIE brand pattern:
 *   • 1 word     → solid (no emerald, keeps visual rhythm)
 *   • 2 words    → first dark + last emerald
 *                  e.g. "Prompt <em>Library</em>"
 *   • 3+ words   → first dark + middle emerald + last dark
 *                  e.g. "Cost <em>Accountability</em> Scorecard"
 *
 * Drop this into any <h1>/<h2> to instantly match the brand:
 *   <h1 className="text-4xl font-bold">
 *     <BrandTitle>SaaS Spend Detective</BrandTitle>
 *   </h1>
 *
 * The emerald shade auto-adapts to light/dark theme.
 */
import React from 'react';

const BrandTitle = ({ children, emeraldClass = 'text-emerald-600 dark:text-emerald-400' }) => {
  const raw = typeof children === 'string' ? children : '';
  const parts = raw.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return null;
  if (parts.length === 1) {
    return <>{raw}</>;
  }
  if (parts.length === 2) {
    return (
      <>
        {parts[0]}{' '}
        <span className={emeraldClass}>{parts[1]}</span>
      </>
    );
  }
  // 3+ words → dark + emerald(middle) + dark(last)
  return (
    <>
      {parts[0]}{' '}
      <span className={emeraldClass}>{parts.slice(1, -1).join(' ')}</span>{' '}
      {parts[parts.length - 1]}
    </>
  );
};

export default BrandTitle;
